<template>
  <div>
    <div class="shadowOverlay" />
    <video
      v-if="isNarrowViewport"
      :poster="`static/videos/home-${name}-poster.1-1.q25.ns50.avif`"
      class="backgroundVideo"
      loop
      muted
      playsinline
      preload="none"
    >
      <source :src="`static/videos/home-${name}.1-1.av1.qp100.mp4`" type="video/mp4; codecs=av01.0.05M.08" />
      <source :src="`static/videos/home-${name}.1-1.hevc.crf28.mp4`" type="video/mp4; codecs=hvc1" />
      <source :src="`static/videos/home-${name}.1-1.avc.crf28.mp4`" type="video/mp4; codecs=avc1.4D401E" />
    </video>
    <video
      v-else
      :poster="`static/videos/home-${name}-poster.16-9.q30.ns50.avif`"
      class="backgroundVideo"
      loop
      muted
      playsinline
      preload="none"
    >
      <source :src="`static/videos/home-${name}.16-9.av1.qp80.mp4`" type="video/mp4; codecs=av01.0.05M.08" />
      <source :src="`static/videos/home-${name}.16-9.hevc.crf24.mp4`" type="video/mp4; codecs=hvc1" />
      <source :src="`static/videos/home-${name}.16-9.avc.crf24.mp4`" type="video/mp4; codecs=avc1.4D401E" />
    </video>
  </div>
</template>

<script setup>
import { bool, string } from 'vue-types'

defineProps({
  isNarrowViewport: bool().isRequired,
  name: string().isRequired,
})
</script>

<style lang="scss" scoped>
@import 'assets/scss/base/bootstrap_variables';

.shadowOverlay {
  position: absolute;
  z-index: 5;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0 / 50%);
}

.backgroundVideo {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 600px;
  object-fit: cover;
  object-position: top;
  max-height: calc(100vh - 70px); // main nav height

  @media (min-width: $screen-sm-min) {
    width: 100%;
    height: auto;
    object-position: center;
  }

  @media (min-width: $screen-md-min) {
    max-height: calc(100vh - 96px);
  }
}
</style>



// WEBPACK FOOTER //
// BackgroundVideo.vue